export default "__VITE_ASSET__BvmNf2x4__";